/**
 * Cookie 条入场、页面 padding-bottom 过渡（可与条同频）。
 * adv-cookie 条上 `cookieAnimation` 多为 2s，留白与条同频时可对齐该量级。
 */
export const COOKIE_LAYOUT_DURATION_MS = 1500;

export const COOKIE_LAYOUT_DURATION_CSS = `${COOKIE_LAYOUT_DURATION_MS / 1000}s`;

/**
 * 协议区补滚须明显短于 Cookie 条入场（约 2s），在条未滑完前完成滚动。
 */
export const COOKIE_SCROLL_DURATION_MS = 500;

/** card-end 吸底：上 0.4（含 address 距按钮 40px）+ 按钮 1.2 + 下 0.4 */
export const CARD_END_STICKY_BTN_TOP_REM = 0.4;
export const CARD_END_STICKY_BTN_BOTTOM_REM = 0.4;
export const CARD_END_STICKY_BTN_HEIGHT_REM = 1.2;
export const CARD_END_PAGE_PADDING_OFFSET_PX = 96;

export const CARD_END_STICKY_CONTENT_REM =
    CARD_END_STICKY_BTN_TOP_REM +
    CARD_END_STICKY_BTN_HEIGHT_REM +
    CARD_END_STICKY_BTN_BOTTOM_REM;

/** 与 cardEndMain BOTTOM_PADDING_OFFSET(96) 配合，页面留白 = cookieHeight + CARD_END_STICKY_CONTENT_REM */
export function getCardEndStickyBottomHeightPx(): number {
    const remPx =
        typeof document !== 'undefined'
            ? parseFloat(getComputedStyle(document.documentElement).fontSize) || 100
            : 100;

    return (
        Math.round(remPx * CARD_END_STICKY_CONTENT_REM) +
        CARD_END_PAGE_PADDING_OFFSET_PX
    );
}
